import { Box, Flex, Heading, Icon, Stack } from 'juhuui';
import React, { forwardRef, useEffect } from 'react';
import shallow from 'zustand/shallow';

import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { BoxRef, Bright, ContainerOuter, grid12, HeadingLg } from '../styles';
import { useStore } from '../zustand';
import { Carousel } from './carousel';

export const PraxisWhy = forwardRef(({ warumCarousel, whyTitle }, ref) => {
  const [whyInView] = useIntersectionObserver(ref, {});

  const [setPraxisInView] = useStore(
    (state) => [state.setPraxisInView],
    shallow
  );

  useEffect(() => {
    if (whyInView) {
      setPraxisInView({ 0: true });
    } else {
      setPraxisInView({ 0: false });
    }
  }, [whyInView]);

  return (
    <Bright>
      <ContainerOuter
        ref={ref}
        className={grid12}
        css={{
          pb: [16, undefined, 0],
          margin: 'auto',
          maxW: 'var(--max-width)',
          px: 'var(--px)',
        }}
      >
        <HeadingLg
          as="h2"
          classNames="col-span-12 pb-10 pointer-events-none whitespace-pre-wrap"
          // css={{
          //   column: '1/span 12',
          //   pb: ['10'],
          //   pointerEvents: 'none',
          //   whiteSpace: 'pre-wrap',
          // }}
        >
          {whyTitle}
        </HeadingLg>
        <Carousel
          css={{
            mt: ['0px'],
            minH: [null, null, 'calc(26vw + 16rem)'],
          }}
          items={warumCarousel}
        />
      </ContainerOuter>
    </Bright>
  );
});
